isotope = require('isotope/dist/isotope.pkgd.min');

$grid = $('.grid').isotope
  itemSelector: '.grid-item'
  layoutMode: 'fitRows'

  $('.filter-button-group').on 'click', 'button', ->
    filterValue = $(this).attr('data-filter')
    $grid.isotope filter: filterValue
    return



// WEBPACK FOOTER //
// ./Components/isotope.coffee